/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"
import { useBrowserLayout } from "@src/utils/hooks/layout"
import Clickable from "@src/components/clickable"

const Layout = ({ children, location }) => {
  const { renderItem } = useBrowserLayout()
  const pathname = location?.pathname

  useEffect(() => {
    if (!pathname) {
      return
    }

    const classList = window.document.body.classList
    const className = `is_${pathname.replace(/\//g, "") || "home"}Page`
    classList.add(className)
    return () => {
      classList.remove(className)
    }
  }, [pathname])

  return (
    <AppContext.Provider value={{ renderItem }}>
      <Seo />
      <div className={styles.container}>
        <main>{children}</main>
      </div>
      <footer className={styles.footer}>
        <div className={styles.footerEmail}>
          <Clickable appNavTo="https://www.gcores.com">
            www.gcores.com
          </Clickable>
        </div>
        <div className={styles.footerRights}>
          GCORES 2023 ALL RIGHTS RESERVED
        </div>
      </footer>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
